import Protagonists from './Protagonists';

export default Protagonists;
